import { AVAILABLE_TEMPLATES } from 'constants/templates';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useResumeStore, { updateResumeData } from 'store/resume';
import TemplateLayout from 'layouts/TemplateLayout';
import { useGetTemplateDetailsForMobileQuery } from 'services';
import './styles.scss';
import Loader from 'components/Common/Loader';

const MobileResumePreview: React.FC = () => {
	const { slug: templateSlug, token } = useParams();

	const resumeData: any = useResumeStore((state) => state?.resumeData);
	const { data: templateData, isPending } = useGetTemplateDetailsForMobileQuery(
		Number(templateSlug),
		token,
	);

	const { component: Template, styles } = useMemo(
		() =>
			AVAILABLE_TEMPLATES.find((template: any) => template.id === Number(templateSlug)) as {
				component: React.ComponentType<any>;
				styles: { [key: string]: any };
			},
		[templateSlug],
	);

	useEffect(() => {
		if (templateData?.data && Object.keys(templateData?.data)?.length > 0) {
			updateResumeData(templateData?.data);
		}
	}, [templateData?.data]);

	return (
		<div className="template-preview-area template-preview-area-web-url h-100 w-100 d-flex align-items-center justify-content-center">
			<div id="resume-preview" className="template-preview-area-inner position-absolute">
				{isPending ? (
					<Loader />
				) : templateData?.success === false ? (
					<h4 className="text-danger d-flex justify-content-center align-items-center text-uppercase vh-100">
						{templateData?.message || 'An error occurred'}
					</h4>
				) : (
					<TemplateLayout isWebView={true} token={token}>
						<Template resumeData={resumeData} styles={styles} isWebView={true} />
					</TemplateLayout>
				)}
			</div>
		</div>
	);
};

export default React.memo(MobileResumePreview);
